
import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import AuthRoute from "@/components/auth/AuthRoute";
import AdminRoute from "@/components/auth/AdminRoute";
import Index from "@/pages/Index";

// Lazy load pages for better code splitting
const Dashboard = lazy(() => import("@/pages/Dashboard").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Dashboard</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Teams = lazy(() => import("@/pages/Teams").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Teams</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Leagues = lazy(() => import("@/pages/Leagues").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Leagues</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const LeagueDetails = lazy(() => import("@/pages/LeagueDetails").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading League</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const TeamProfile = lazy(() => import("@/pages/TeamProfile").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Team</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Settings = lazy(() => import("@/pages/Settings").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Settings</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Contact = lazy(() => import("@/pages/Contact").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Contact</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Rules = lazy(() => import("@/pages/Rules").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Rules</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Messages = lazy(() => import("@/pages/Messages").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Messages</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Notifications = lazy(() => import("@/pages/Notifications").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Notifications</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Tickets = lazy(() => import("@/pages/Tickets").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Tickets</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const TicketDetails = lazy(() => import("@/pages/TicketDetails").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Ticket</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Fixtures = lazy(() => import("@/pages/Fixtures").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Fixtures</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Standings = lazy(() => import("@/pages/Standings").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Standings</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const News = lazy(() => import("@/pages/News").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading News</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const NewsArticle = lazy(() => import("@/pages/NewsArticle").catch(() => ({ 
  default: () => (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">Error Loading Article</h1>
      <p className="text-muted-foreground mb-4">Failed to load the news article. Please refresh the page.</p>
      <button 
        onClick={() => window.location.reload()} 
        className="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
      >
        Refresh Page
      </button>
    </div>
  )
})));
const Transfers = lazy(() => import("@/pages/Transfers").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Transfers</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const PlayerProfile = lazy(() => import("@/pages/PlayerProfile").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Player</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const MatchDetails = lazy(() => import("@/pages/MatchDetails").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Match</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Profile = lazy(() => import("@/pages/Profile").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Profile</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const NightCupList = lazy(() => import("@/pages/NightCupList").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Night Cup</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const NightCupDetails = lazy(() => import("@/pages/NightCupDetails").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Night Cup</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const ComingSoon = lazy(() => import("@/pages/ComingSoon").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Page</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Login = lazy(() => import("@/pages/Login").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Login</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Register = lazy(() => import("@/pages/Register").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Register</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Page</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const ResetPassword = lazy(() => import("@/pages/ResetPassword").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Page</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const NotFound = lazy(() => import("@/pages/NotFound").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">404 - Page Not Found</h1><button onClick={() => window.location.href = '/'} className="px-4 py-2 bg-primary text-primary-foreground rounded">Go Home</button></div> })));
const Transfercenter = lazy(() => import("@/pages/Transfercenter").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Transfer Center</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const DatabaseStatus = lazy(() => import("@/pages/DatabaseStatus").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Database Status</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminTest = lazy(() => import("@/pages/AdminTest").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Test</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));

// Admin routes - lazily loaded
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Dashboard</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminUsers = lazy(() => import("@/pages/AdminUsers").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Users</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminNews = lazy(() => import("@/pages/AdminNews").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin News</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminLeagues = lazy(() => import("@/pages/AdminLeagues").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Leagues</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminTeams = lazy(() => import("@/pages/AdminTeams").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Teams</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminSchedule = lazy(() => import("@/pages/AdminSchedule").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Schedule</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminMatchReports = lazy(() => import("@/pages/AdminMatchReports").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Match Reports</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminSponsors = lazy(() => import("@/pages/AdminSponsors").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Sponsors</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminContracts = lazy(() => import("@/pages/AdminContracts").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Contracts</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminTeamEligibility = lazy(() => import("@/pages/AdminTeamEligibility").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Team Eligibility</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const AdminTickets = lazy(() => import("@/pages/AdminTickets").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Admin Tickets</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const Setup = lazy(() => import("@/pages/Setup").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Setup</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));
const CaptainPanel = lazy(() => import("@/pages/CaptainPanel").catch(() => ({ default: () => <div className="flex flex-col items-center justify-center min-h-screen p-4"><h1 className="text-2xl font-bold mb-4">Error Loading Captain Panel</h1><button onClick={() => window.location.reload()} className="px-4 py-2 bg-primary text-primary-foreground rounded">Refresh</button></div> })));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center h-screen bg-league-background">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-league-primary"></div>
  </div>
);

// Error boundary component for lazy loading
const LazyErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingFallback />}>
    {children}
  </Suspense>
);

// Wrap component with Suspense and error handling
const withSuspense = (Component: React.ComponentType) => (
  <LazyErrorBoundary>
    <Component />
  </LazyErrorBoundary>
);

// Create route objects once, not on every render
const publicRoutes = [
  {
    path: "/login",
    element: withSuspense(Login)
  },
  {
    path: "/register",
    element: withSuspense(Register)
  },
  {
    path: "/forgot-password",
    element: withSuspense(ForgotPassword)
  },
  {
    path: "/reset-password",
    element: withSuspense(ResetPassword)
  },
  {
    path: "/coming-soon",
    element: withSuspense(ComingSoon)
  }
];

const standardRoutes = [
  {
    path: "/dashboard",
    element: <AuthRoute>{withSuspense(Dashboard)}</AuthRoute>
  },
  {
    path: "/teams",
    element: <AuthRoute>{withSuspense(Teams)}</AuthRoute>
  },
  {
    path: "/teams/:id",
    element: <AuthRoute>{withSuspense(TeamProfile)}</AuthRoute>
  },
  {
    path: "/leagues",
    element: <AuthRoute>{withSuspense(Leagues)}</AuthRoute>
  },
  {
    path: "/leagues/:id",
    element: <AuthRoute>{withSuspense(LeagueDetails)}</AuthRoute>
  },
  {
    path: "/fixtures",
    element: <AuthRoute>{withSuspense(Fixtures)}</AuthRoute>
  },
  {
    path: "/matches/:id",
    element: <AuthRoute>{withSuspense(MatchDetails)}</AuthRoute>
  },
  {
    path: "/standings",
    element: <AuthRoute>{withSuspense(Standings)}</AuthRoute>
  },
  {
    path: "/news",
    element: <AuthRoute>{withSuspense(News)}</AuthRoute>
  },
  {
    path: "/news/:id",
    element: <AuthRoute>{withSuspense(NewsArticle)}</AuthRoute>
  },
  {
    path: "/messages",
    element: <AuthRoute>{withSuspense(Messages)}</AuthRoute>
  },
  {
    path: "/notifications",
    element: <AuthRoute>{withSuspense(Notifications)}</AuthRoute>
  },
  {
    path: "/tickets",
    element: <AuthRoute>{withSuspense(Tickets)}</AuthRoute>
  },
  {
    path: "/tickets/:id",
    element: <AuthRoute>{withSuspense(TicketDetails)}</AuthRoute>
  },
  {
    path: "/settings",
    element: <AuthRoute>{withSuspense(Settings)}</AuthRoute>
  },
  {
    path: "/contact",
    element: <AuthRoute>{withSuspense(Contact)}</AuthRoute>
  },
  {
    path: "/rules",
    element: <AuthRoute>{withSuspense(Rules)}</AuthRoute>
  },
  {
    path: "/captain",
    element: <AuthRoute>{withSuspense(CaptainPanel)}</AuthRoute>
  },
  {
    path: "/captain/:section",
    element: <AuthRoute>{withSuspense(CaptainPanel)}</AuthRoute>
  }
];

const adminRoutes = [
  {
    path: "/admin/dashboard",
    element: <AuthRoute adminOnly>{withSuspense(AdminDashboard)}</AuthRoute>
  },
  {
    path: "/admin/users",
    element: <AuthRoute adminOnly>{withSuspense(AdminUsers)}</AuthRoute>
  },
  {
    path: "/admin/news",
    element: <AuthRoute adminOnly>{withSuspense(AdminNews)}</AuthRoute>
  },
  {
    path: "/admin/leagues",
    element: <AuthRoute adminOnly>{withSuspense(AdminLeagues)}</AuthRoute>
  },
  {
    path: "/admin/teams",
    element: <AuthRoute adminOnly>{withSuspense(AdminTeams)}</AuthRoute>
  },
  {
    path: "/admin/team/:id/eligibility",
    element: <AuthRoute adminOnly>{withSuspense(AdminTeamEligibility)}</AuthRoute>
  },
  {
    path: "/admin/schedule",
    element: <AuthRoute adminOnly>{withSuspense(AdminSchedule)}</AuthRoute>
  },
  {
    path: "/admin/match-reports",
    element: <AuthRoute adminOnly>{withSuspense(AdminMatchReports)}</AuthRoute>
  },
  {
    path: "/admin/sponsors",
    element: <AuthRoute adminOnly>{withSuspense(AdminSponsors)}</AuthRoute>
  },
  {
    path: "/admin/contracts",
    element: <AuthRoute adminOnly>{withSuspense(AdminContracts)}</AuthRoute>
  },
  {
    path: "/admin/tickets",
    element: <AuthRoute adminOnly>{withSuspense(AdminTickets)}</AuthRoute>
  },
  {
    path: "/setup",
    element: <AuthRoute adminOnly>{withSuspense(Setup)}</AuthRoute>
  }
];

const additionalRoutes = [
  {
    path: "/transfers",
    element: <AuthRoute>{withSuspense(Transfers)}</AuthRoute>
  },
  {
    path: "/transfercenter", 
    element: <AuthRoute>{withSuspense(Transfercenter)}</AuthRoute>
  },
  {
    path: "/database-status",
    element: withSuspense(DatabaseStatus)
  },
  {
    path: "/admin-test",
    element: withSuspense(AdminTest)
  },
  {
    path: "/players/:id",
    element: <AuthRoute>{withSuspense(PlayerProfile)}</AuthRoute>
  },
  {
    path: "/profile",
    element: <AuthRoute>{withSuspense(Profile)}</AuthRoute>
  },
  {
    path: "/night-cup",
    element: <AuthRoute>{withSuspense(NightCupList)}</AuthRoute>
  },
  {
    path: "/night-cup/:id",
    element: <AuthRoute>{withSuspense(NightCupDetails)}</AuthRoute>
  }
];

export const createAppRouter = (isMaintenanceMode: boolean, user: any, isLoading: boolean) => {
  // Don't create routes if still loading auth or maintenance status
  if (isLoading) {
    return null;
  }
  
  // Determine root route based on authentication status
  const rootRoute = {
    path: "/",
    element: user ? <Navigate to="/dashboard" /> : <Index />
  };
  
  // Conditional routes - handle maintenance mode
  const processedStandardRoutes = isMaintenanceMode && !user 
    ? standardRoutes.map(route => ({...route, element: <Navigate to="/coming-soon" />})) 
    : standardRoutes;
  
  // Combine all routes with the conditional processing
  const allRoutes = [
    rootRoute,
    ...publicRoutes,
    ...processedStandardRoutes,
    ...adminRoutes,
    ...additionalRoutes,
    {
      path: "*",
      element: isMaintenanceMode && !user ? <Navigate to="/coming-soon" /> : withSuspense(NotFound)
    }
  ];
  
  return createBrowserRouter(allRoutes);
};
